import { render, staticRenderFns } from "./SkinList.vue?vue&type=template&id=39371ff6&"
import script from "./SkinList.vue?vue&type=script&lang=js&"
export * from "./SkinList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports